import template from './prems-discount-category-detail-statistics.html.twig';
import './prems-discount-category-detail-statistics.scss';

const { Criteria } = Shopware.Data;

Shopware.Component.register('prems-discount-category-detail-statistics', {
    template,

    inject: ['repositoryFactory'],

    props: {
        discountCategory: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            records: null,
            isLoading: false,
            totalMargin: 0,
            totalAmount: 0
        }
    },

    computed: {
        statisticsRepository() {
            return this.repositoryFactory.create('prems_discount_category_statistics');
        },

        statisticsColumns() {
            return [
                {
                    property: 'name',
                    label: this.$tc('prems-discount-category.detail.card.statistics.field.name'),
                    sortable: false
                },
                {
                    property: 'productNumber',
                    label: this.$tc('prems-discount-category.detail.card.statistics.field.productNumber'),
                    sortable: false
                },
                {
                    property: 'sales',
                    label: this.$tc('prems-discount-category.detail.card.statistics.field.sales')
                },
                {
                    property: 'margin',
                    label: this.$tc('prems-discount-category.detail.card.statistics.field.totalMargin'),
                    sortable: false
                },
                {
                    property: 'turnover',
                    label: this.$tc('prems-discount-category.detail.card.statistics.field.turnover')
                },
            ];
        },
        assetFilter() {
            return Shopware.Filter.getByName('asset');
        },
    },

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.isLoading = true;

            this.refreshList();
        },

        refreshList() {
            let criteria = new Criteria();
            if (!this.records || !this.records.criteria) {
                criteria.addFilter(Criteria.equals('prems_discount_category_statistics.discountCategoryId', this.discountCategory.id));
                criteria.addAssociation('product');
            } else {
                criteria = this.records.criteria;
            }

            this.statisticsRepository.search(criteria, { ...Shopware.Context.api, inheritance: true }).then((records) => {
                this.records = records;
                this.isLoading = false;
            }).finally(() => {
                const { totalAmount, totalMargin } = this.records.reduce(
                    (totals, record) => {
                        totals.totalAmount += record.turnover.totalPrice;
                        totals.totalMargin += record.turnover.totalPrice - record.turnover.netPrice;
                        return totals;
                    },
                    { totalAmount: 0, totalMargin: 0 }
                );

                this.totalAmount = totalAmount;
                this.totalMargin = totalMargin;
            });
        },
    }
});
